import * as React from 'react';
import { useState } from 'react';

import { Card, CardContent } from '@klareospace/pharos-lib-web-utils';

import { HandlingUnitTypeDrawer, HandlingUnitTypesActionBar, HandlingUnitTypesTable } from '../components';
import { useHandlingUnitTypesPage } from '../hooks';

export default function HandlingUnitTypesPage(): React.JSX.Element {
  const pageState = useHandlingUnitTypesPage();

  const [drawerOpen, setDrawerOpen] = useState(false);

  function handleAdd(): void {
    setDrawerOpen(true);
  }

  function handleDrawerClose(): void {
    setDrawerOpen(false);
  }

  if (pageState.error) {
    throw pageState.error;
  }

  return (
    <div className="flex h-full flex-1 flex-col gap-4">
      <HandlingUnitTypesActionBar onAdd={handleAdd} />
      <Card className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl shadow-sm">
        <CardContent className="flex min-h-0 flex-1 flex-col p-0">
          <HandlingUnitTypesTable
            handlingUnitTypes={pageState.handlingUnitTypes}
            isLoading={pageState.isLoading}
            pagination={{
              currentPage: pageState.currentPage,
              onPageChange: pageState.onPageChange,
              pageSize: pageState.pageSize,
              totalItems: pageState.totalItems,
              totalPages: pageState.totalPages,
            }}
          />
        </CardContent>
      </Card>
      <HandlingUnitTypeDrawer handlingUnitType={null} onClose={handleDrawerClose} open={drawerOpen} />
    </div>
  );
}
